<template>
<div>
    <b-container v-if="progress_load_indicator" class="text-left">
        <b-button-group class="mb-5">
            <b-button :pressed="display_filled_rate==false" :variant="display_filled_rate?'gray':'dark'" class="f-110" @click="changeProgressMode(false)">신청 및 제출 현황</b-button>
            <b-button :pressed="display_filled_rate==true" :variant="display_filled_rate?'dark':'gray'" class="f-110" @click="changeProgressMode(true)">답변 입력 현황</b-button>
        </b-button-group>        

        <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0 fw-600">  기업별 {{ display_filled_rate? `진행률` : `제출률` }}</h5>
            <b-button-group class="">
                <b-button :pressed="is_summary_mode_overall==true" :variant="is_summary_mode_overall?'dark':'gray'" class="" @click="is_summary_mode_overall=true"> 종합 </b-button>
                <b-button :pressed="is_summary_mode_overall==false" :variant="is_summary_mode_overall?'gray':'dark'" class="" @click="is_summary_mode_overall=false"> 상세보기 </b-button>
            </b-button-group>      
        </div>

        <div v-if="is_summary_mode_overall==true">
            <section class="d-flex align-items-stretch">
                <b-table-simple responsive hover class="rep-table">
                    <b-thead>
                        <b-tr>
                            <b-td class="border-top border-color-gray-700 border-width-2" rowspan="2">프로젝트 코드 </b-td>
                            <b-td class="border-top border-color-gray-700 border-width-2" style="width: 15%;" rowspan="2">기업명 </b-td>
                            <b-td class="border-top border-color-gray-700 border-width-2" rowspan="2">상태 코드 </b-td>
                            <b-td v-if="display_filled_rate==false" class="border-top border-color-gray-700 border-width-2" rowspan="2" style="width: 90px">시작일 </b-td>
                            <b-td v-if="display_filled_rate==false" class="border-top border-color-gray-700 border-width-2" rowspan="2" style="width: 90px">제출일 </b-td>
                            <b-td v-if="display_filled_rate==false" class="border-top border-color-gray-700 border-width-2" rowspan="2" style="width: 90px">결과배포일 </b-td>

                            <b-td class="border-top border-color-gray-700 border-width-2" style="min-width: 250px" rowspan="2"> {{ display_filled_rate? `진행률` : `제출률` }}
                                <fa v-if="sorted=='sort'" icon="sort" class="gray-500" style="cursor:pointer;" @click="toggleSorted(display_filled_rate, 'sort-down')"></fa>
                                <fa v-else-if="sorted=='sort-up'" icon="sort-up" class="gray-500" style="cursor:pointer;" @click="toggleSorted(display_filled_rate, 'sort')"></fa>
                                <fa v-else-if="sorted=='sort-down'" icon="sort-down" class="gray-500" style="cursor:pointer;" @click="toggleSorted(display_filled_rate, 'sort-up')"></fa></b-td>
                            <b-td class="border-top border-color-gray-700 border-width-2" :colspan="category_names.length">문항 부문별 {{ display_filled_rate? `진행률` : `제출률` }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td v-for="ctem in category_names" :key="ctem.id" v-b-tooltip.hover class="f-85 hover-gray" style="width: 60px;" :title="ctem">{{ category_name_to_code(ctem) }}</b-td>
                        </b-tr>
                    </b-thead>
                    <b-tbody v-if="is_progress_rate_loaded==true">
                        <!-- 제출률 -->
                        <template v-if="display_filled_rate==false">  
                            <b-tr v-for="item in temp_target_companies" :key="`${item.project_code}-${item.company_id}`">
                                <b-td class="f-90 gray-800">  {{ item.project_code }} </b-td>
                                <b-td class="f-90 gray-800">  {{ item.company_name }} </b-td>
                                <b-td class="f-90 gray-800">  {{ getNiceServiceStatus(item.company_id) }} </b-td>
                                <b-td class="f-85" :class="getNiceServiceStatus(item.company_id)=='in_progress'?'blue':'gray-550'">  {{ getNiceServiceTimeStamp(item.company_id, 'in_progress') }} </b-td>
                                <b-td class="f-85" :class="getNiceServiceStatus(item.company_id)=='in_assessment'?'blue':'gray-550'">  {{ getNiceServiceTimeStamp(item.company_id, 'in_assessment') }} </b-td>
                                <b-td class="f-85" :class="getNiceServiceStatus(item.company_id)=='completed'?'blue':'gray-550'">  {{ getNiceServiceTimeStamp(item.company_id, 'completed') }} </b-td>

                                <b-td> 
                                    <b-progress :class="getTotalProgressRate(item.company_id)==100? 'thin-progress': 'category-progress'" height="0.9rem">
                                        <b-progress-bar :value="getTotalProgressRate(item.company_id)" :label="`${Math.floor(getTotalProgressRate(item.company_id))}%`"></b-progress-bar>
                                    </b-progress>
                                </b-td>
                                <b-td v-for="c_name in category_names" :key="c_name.id">
                                    <span class="f-90">{{ Math.floor(getCategoryProgressRate(item.company_id)[c_name])}}%</span>
                                </b-td>                            
                            </b-tr>                            
                        </template>
                        <!-- 진행률 -->
                        <template v-else>
                            <b-tr v-for="jtem in temp_target_companies" :key="`${jtem.project_code}-${jtem.company_id}`">
                                <b-td class="f-90 gray-800"> {{ jtem.project_code }} </b-td>
                                <b-td class="f-90 gray-800"> {{ jtem.company_name }} </b-td>
                                <b-td class="f-90 gray-800">  {{ getNiceServiceStatus(jtem.company_id) }} </b-td>
                                <b-td>
                                    <b-progress class="thin-progress" height="0.9rem">
                                        <b-progress-bar :value="getTotalFilledRate(jtem.company_id)" :label="`${Math.floor(getTotalFilledRate(jtem.company_id))}%`"></b-progress-bar>
                                    </b-progress>
                                </b-td>
                                <b-td v-for="c_name in category_names" :key="c_name.id">
                                    <span class="f-90">{{ Math.floor(getCategoryFilledRate(jtem.company_id)[c_name])}}%</span>
                                </b-td>                      
                            </b-tr>                            
                        </template>
                    </b-tbody>           
                </b-table-simple>
                
            </section>
        </div> 
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        
        <div v-else> 
            <section class="py-4 mb-5 bgray-100 d-flex align-items-stretch">
                <b-col class="col-3 col-xl-2 px-3 border-right border-color-gray-300">
                    <b-input-group> 
                        <b-form-input v-model="search_keyword" placeholder="기업 검색"></b-form-input>
                        <b-input-group-append><b-button variant="icon-append"><fa icon="search"></fa></b-button></b-input-group-append>
                    </b-input-group>

                    <h6 class="mt-5 pb-1 border-bottom border-color-gray-300 f-90 fw-500 gray-500">전체 기업 ({{ temp_target_companies.length }}개사) </h6>
                    <div class="overflow-auto" style="max-height: 800px;">
                        <b-button v-for="(ztem, index) in filtered_companies" :key="index" block :variant="ztem.company_name == temp_target_companies[idx].company_name ?'icon-blue':'icon'" 
                        class="f-90 m-0 py-1 px-2 text-left overflow-hidden no-shadow" @click="selectCompany(ztem)"
                        > {{ ztem.company_name }}
                        </b-button>
                    </div>
                </b-col>
                <b-col class="col-9 col-xl-10 px-md-4">
                    <div class="f-110 fw-600 pb-2 border-bottom border-color-gray-300"> {{ temp_target_companies[idx].company_name }} {{ display_filled_rate? `진행률` : `제출률` }}</div>

                    <div v-if="display_filled_rate==true" class="d-flex flex-wrap justify-content-around align-items-center my-4">
                        <div class="total-progress-charter">
                            <!-- <progress-chart :category_name="`답변률 Total`" :progress_rate="getTotalFilledRate(temp_target_companies[idx].company_id)" :background_color="company_total_dounut" :key="re_total" class="total-progress-charter"></progress-chart> -->
                            <div :class="[getTotalFilledRate(temp_target_companies[idx].company_id) > 0 ? 'blue':'gray-600','total-progress-dounut-inner']"> 
                                <span class="f-160 fw-600">{{ Math.round(getTotalFilledRate(temp_target_companies[idx].company_id))}}</span>% 
                            </div>
                        </div>
                        <div v-for="ca_name in category_names" :key="ca_name.id" class="progress-charter">
                            <!-- <progress-chart :category_name="ca_name" :progress_rate="getCategoryFilledRate(temp_target_companies[idx].company_id)[ca_name]" :background_color="company_category_dounut" :key="re_category" class="progress-charter"></progress-chart> -->
                            <div class="progress-dounut-inner"> 
                                <span class="f-120 fw-600">{{ Math.floor(getCategoryFilledRate(temp_target_companies[idx].company_id)[ca_name]) }}</span>%
                            </div>        
                        </div>
                        
                    </div>
                    <div v-else class="d-flex flex-wrap justify-content-around align-items-center my-4">
                        <div class="total-progress-charter">
                            <!-- <progress-chart :category_name="`제출률 Total`" :progress_rate="getTotalProgressRate(temp_target_companies[idx].company_id)" :background_color="company_total_dounut" :key="re_total" class="total-progress-charter"></progress-chart> -->
                            <div :class="[getTotalProgressRate(temp_target_companies[idx].company_id)> 0 ? 'blue':'gray-600','total-progress-dounut-inner']"> 
                                <span class="f-160 fw-600">{{ Math.round(getTotalProgressRate(temp_target_companies[idx].company_id)) }}</span>% 
                            </div>                       
                        </div>
                        <div v-for="ca_name in category_names" :key="ca_name.id" class="progress-charter">
                            <!-- <progress-chart :category_name="ca_name" :progress_rate="getCategoryProgressRate(temp_target_companies[idx].company_id)[ca_name]" :background_color="company_category_dounut" :key="re_category" class="progress-charter"></progress-chart> -->
                            <div class="progress-dounut-inner"> 
                                <span class="f-120 fw-600">{{ Math.round(getCategoryProgressRate(temp_target_companies[idx].company_id)[ca_name]) }}</span>%
                            </div>        
                        </div>
                    </div>
                    <!-- <tree :data="temp_target_companies[idx].progress_contents" :prevent-select="false" :draggable="false" :space="1" :indent="0" class="px-2 px-lg-4 pb-4 clearfix overflow-auto">
                    <template v-slot="{data}">
                        <b-row
                        :class="[`node-level-${data._vm.level}`, 'mx-0 text-left border-bottom border-color-gray-300 d-flex align-items-stretch']" style="min-width:400px;">
                            <b-col :class="[`node-level-${data._vm.level}-sub`, 'col-7 col-md-8 py-1 pr-0 d-flex align-items-center']"> {{ data.question_name }} </b-col>
                            <b-col class="col-auto d-flex align-items-center text-center">
                                <span v-if="checkCompleted(data)!=''" :class ="[ checkCompleted(data) != '완료' ? 'on-completed':'on-track','fw-600']"> {{ checkCompleted(data) }} </span>
                                <fa v-if="checkCompleted(data)!='' && checkCompleted(data)== '완료'" :icon="['far','check-circle']" class="ml-1 gray-600"></fa>
                                <span v-else style="display: none;"></span>
                            </b-col>
                        </b-row>
                    </template>
                    </tree> -->
                </b-col>
            </section>
        </div> <!-- end of is_summary_mode_overall == false -->

    </b-container>
    <b-container v-else-if="load_error">
        <PageEmptyComponent compact :error="load_error" @retry="loadProgress" />
    </b-container>
    <b-container v-else-if="is_data_loaded && !sub_layout_loading">
        <PageEmptyComponent compact text="참여 기업이 없습니다." />
    </b-container>
    <b-container v-else>
        <b-card class="my-5 border-0 blue text-center align-items-center"> <b-spinner class="mx-2 p-1 my-1" small type="grow"></b-spinner>진행률을 가져오고 있습니다... </b-card>
    </b-container>
    <hr class="border-0 bottom-space">

</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { getErrorMessage } from '@core/utils/api/errorMessage';
import PageEmptyComponent from '@shared_components/admin/components/common/PageEmptyComponent.vue';
// import ProgressChart from '@shared_components/admin/components/charts/ProgressChart'
// import CompanyFinder from '../managing_user/CompanyFinder'
// import {DraggableTree} from 'vue-draggable-nested-tree'
// import * as ih from '@core_utils/util'
// import * as th from 'tree-helper'
// import GeneralPrintButton from '@shared_components/admin/components/common/GeneralPrintButton'


export default {
    components:{
        PageEmptyComponent,
        // CompanyFinder,
        // ProgressChart,
        // 'tree': DraggableTree,
        // GeneralPrintButton
    },
    data() {
        return {
            category_names: [],
            local_template_tree_contents_original: [],

            // temp_target_companies: [{ company_code: 0, company_name: "Company a", total_progress: 30
            //category_progress: { category_A: 10, category_B: 20, category_C: 30, cateogry_D: 40 }, 
            //category_filled_rate: { category_A: 10, ... }, 
            //category_num_of_subs_init: { category_A: 10... }, 
            //category_num_of_filled: { category_A: 10...}, 
            //progress_contents: [ {category_a: 70 }, {category_b: 60}, {category_c: 55}, {category_d: 20} ]},
            //                { company_code: 1, company_name: "Company b", progress_a: 80, prgress_b: 55, progress_c: 45, progress_d: 80 },
            //                { company_code: 2, company_name: "Company c", progress_a: 40, prgress_b: 74, progress_c: 35, progress_d: 40 },
            //                { company_code: 3, company_name: "Company d", progress_a: 96, prgress_b: 50, progress_c: 52, progress_d: 10 }]

            is_data_loaded: false,
            load_error: '',
            idx: 0,

            is_progress_loaded: false,
            search_keyword: '',
            company_total_dounut: ['rgba(61, 90, 254, 1)'],
            company_category_dounut: ['rgba(173, 185, 255, 1)'],
            re_total: 0,
            re_category: 10,
            display_filled_rate: false,
            is_summary_mode_overall: true, // 'companies' or 'overall'
            sorted: 'sort'
        };
    },
    computed:{
        ...mapState('score', ['temp_target_companies']),
        ...mapState('admin', ['sub_layout_loading']),
        ...mapState('industry_campaigns', ['nice_services_status', 'category1_filled_rate', 'total_filled_rate', 'category1_progress_rate', 'total_progress_rate', 'is_progress_rate_loaded' ]),
        progress_load_indicator() {
            return this.is_data_loaded && this.temp_target_companies.length > 0;
        },
        campaign() {
            return this.$store.state.campaign;
        },
        campaign_id(){
            return this.$route.query.cmp ?? this.$route.query.campaign_id ?? this.campaign.campaign_id;
        },
        template_code(){
            return this.$route.query.template_code;
        },
        template_contents(){
            return this.$store.state.template_tree.template_contents;
        },
        filtered_companies(){
            if(this.search_keyword=='') { return this.temp_target_companies; }
            else{
                let return_array = [];
                for(let i=0; i<this.temp_target_companies.length; i++){
                    if(this.temp_target_companies[i].company_name.search(this.search_keyword) >= 0){
                        return_array.push(this.temp_target_companies[i]);
                    }
                }
                return return_array;
            }
        }
    },
    async created() {
        await this.loadProgress();
    },
    beforeDestroy(){
        this.update_nice_service_status([]);
        this.update_nice_service_status_loaded(false);
    },
    methods:{
        ...mapMutations('industry_campaigns', ['update_nice_service_status', 'update_nice_service_status_loaded']),
        ...mapActions('industry_campaigns', ['readNiceServiceStatus', 'readFilledRate', 'readProgressRate']),
        async loadProgress() {
            this.load_error = '';
            this.is_data_loaded = false;
            try {
                await Promise.all([
                    this.readNiceServiceStatus({campaign_id: this.campaign_id}),
                    this.readFilledRate({campaign_id: this.campaign_id}),
                    this.readProgressRate({campaign_id: this.campaign_id}),
                    this.$store.dispatch('readTemplateTree',{template_code:this.template_code, is_previous:false})
                ]);
                this.category_names = Array.from(this.template_contents.map(x => x.question_name));
                this.local_template_tree_contents_original = this.template_contents;
                this.is_data_loaded = true;
            } catch (error) {
                this.load_error = getErrorMessage(error, '진행현황을 불러오지 못했습니다.');
            }
        },
        getTotalFilledRate(company_id){
            let jdx = this.total_filled_rate.findIndex(x => x.company_id==company_id);
            if(jdx >-1){
                return this.total_filled_rate[jdx].filled_rate*100;
            }
            else return 0;
        },
        getCategoryFilledRate(company_id){
            let by_company = this.category1_filled_rate.filter(y => y.company_id == company_id);
            let temp_obj = {};
            by_company.forEach(z => {
                temp_obj[z.category1_name] = z.filled_rate*100; 
            });
            return temp_obj;
        },
        getTotalProgressRate(company_id){
            let jdx = this.total_progress_rate.findIndex(x => x.company_id==company_id);
            if(jdx >-1){
                return this.total_progress_rate[jdx].completed_rate*100;
            }
            else return 0;
        },
        getCategoryProgressRate(company_id){
            let by_company = this.category1_progress_rate.filter(y => y.company_id == company_id);
            let temp_obj = {};
            by_company.forEach(z => {
                temp_obj[z.category1_name] = z.completed_rate*100; 
            });
            return temp_obj;
        },
        selectCompany(company_item){
            let index = this.temp_target_companies.findIndex(item => { return item.company_id == company_item.company_id; } );
            if (index > -1){
                this.idx = index;
            }
            this.re_total += 1;
            this.re_category += 11;
        },
        checkCompleted(node){
            if(node.children && node.children.length) return '';

            if(node.is_completed == 'true') { return '완료'; }
            else return '진행중';
        },
        changeProgressMode(mode){
            this.$nextTick(()=>{
                this.re_total += 2;
                this.re_category += 10;
            });
            this.display_filled_rate = mode;
        },
        toggleSorted(is_target_filled_rate, mode){
            this.sorted = mode;
            if(mode == 'sort'){
                this.temp_target_companies.sort( function(a, b) {
                    return a.company_id - b.company_id;
                });
            }
            else if(mode == 'sort-down'){
                if(is_target_filled_rate == true){
                    this.temp_target_companies.sort( function (a, b) {
                        return b.total_filled_rate - a.total_filled_rate;
                    });
                }
                else{
                    this.temp_target_companies.sort( function (a, b){
                        return b.total_progress - a.total_progress;
                    });
                }
            }
            else if(mode == 'sort-up'){
                if(is_target_filled_rate == true){
                    this.temp_target_companies.sort( function (a, b) {
                        return a.total_filled_rate - b.total_filled_rate;
                    });
                }
                else{
                    this.temp_target_companies.sort( function (a, b){
                        return a.total_progress - b.total_progress;
                    });
                }
            }
        },
        getNiceServiceStatus(company_id){
            let idx = this.nice_services_status.findIndex(x => x.company_id == company_id);
            if(idx > -1){
                return this.nice_services_status[idx].status_code;
            }else return '-';
        },
        getNiceServiceTimeStamp(company_id, status_str){
            let idx = this.nice_services_status.findIndex(x => x.company_id == company_id);
            let temp_ts = status_str+'_ts';
            if(idx > -1){    
                if(this.nice_services_status[idx][temp_ts]!=null&&this.nice_services_status[idx][temp_ts]!='NaT'){
                    return this.nice_services_status[idx][temp_ts];
                }else return '-';                
            }else return '-';
        },
        category_name_to_code(category_name){
            if (category_name=='환경') return 'E';
            if (category_name=='인권 및 노동') return 'S';
            if (category_name=='윤리 및 지배구조') return 'G';
            if (category_name=='제품 및 서비스 책임') return 'R';
        }
    }
};
</script>

<style scoped>
.total-progress-charter {
    max-width: 150px;
}
.total-progress-dounut-inner{
    margin-top: -77px;
    margin-bottom: 60px;
    text-align: center;
}
.progress-charter {
    max-width: 130px;
}
.progress-dounut-inner{
    margin-top: -63px;
    margin-bottom: 60px;
    text-align: center;
}
.thin-progress, .category-progress {
    background-color: rgba(150, 150, 150, 0.2)!important;
}

.thin-progress > .progress-bar {
    background-color: var(--blue);
}

.category-progress > .progress-bar {
    background-color: var(--blue4);
}

.overall-company-progress > .progress-bar{
    background-color: var(--blue);
}

.on-track{
    color: var(--gray-600)!important;
    font-size: 0.9rem;
    line-height: 1.2;
}
.on-completed {
    color: var(--blue)!important;
    font-size: 0.9rem;
    line-height: 1.2;
}
.node-level-1 {
    background-color: var(--gray-300);
    font-weight: 600;
}
.node-level-2 {
    background-color: var(--gray-200);
    font-weight: 500;
}
.node-level-1-sub {
    padding-left: 1.5rem!important;
}
.node-level-2-sub {
    padding-left: 2.75rem!important;
}
.node-level-3-sub {
    padding-left: 2.75rem!important;
}
/* .active {
    border:1px solid var(--blue)!important;
    color: var(--blue)!important;
} */

.top-tri{
    position: relative;
    margin-top: 17px;
}
.top-tri::before{
    position: absolute;
    top: -17px;
    height: 0;
    width: 0;
    left: 0;
    border: 7px solid transparent;
    border-bottom-color: var(--blue);
    content: "";
}
</style>
